import React from 'react'
import styled from 'styled-components'
import SmallPlayingCard from '../PlayingCards/SmallPlayingCard'
import Card from 'shared/Card'
import * as EvenlySpaced from 'shared/content-control/EvenlySpaced'

const Wrapper = styled(Card)`
  color: white;
  border-radius: 0.4rem;
  padding: 0.6rem;
  text-align: center;
`

const SmallDecks = ({ discardCard }) => (
  <SmallDecksWrapper>
    <SmallPlayingCard />
    <SmallPlayingCard id={discardCard} />
  </SmallDecksWrapper>
)

export const SmallDecksWrapper = ({ children }) => (
  <Wrapper>
    <EvenlySpaced.Column style={{ gap: '.5rem' }}>
      <EvenlySpaced.Row style={{ gap: '.4rem' }}>{children}</EvenlySpaced.Row>
    </EvenlySpaced.Column>
    <div>
      <span>Decks</span>
    </div>
  </Wrapper>
)

export default SmallDecks
